var map = {
	"./Pic 1.jpg": 901,
	"./Pic 2.jpg": 8329,
	"./Pic 20.jpeg": 2371,
	"./image (24).png": 2433,
	"./pic 10.jpg": 9555,
	"./pic 12.jpg": 8540,
	"./pic 13.jpg": 5461,
	"./pic 14.jpg": 434,
	"./pic 15.jpg": 5547,
	"./pic 16.jpg": 7178,
	"./pic 18.jpg": 4874,
	"./pic 19.jpg": 9295,
	"./pic 22.jpeg": 5047,
	"./pic 23.jpg": 5174,
	"./pic 24.jpg": 1100,
	"./pic 25.jpg": 6954,
	"./pic 4.jpg": 5721,
	"./pic 5.jpg": 2317,
	"./pic 6.jpeg": 2286,
	"./pic 8.jpg": 3921,
	"./pic 9.jpg": 5825,
	"./pic7.jpg": 6772,
	"./yoga 1.jpg": 9710,
	"./yoga 3.jpg": 754,
	"./yoga.png": 3852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1845;